import { markItemRead, markItemUnread } from '../../API';
import { monitor } from '../actions';
import formatItem from '../../../shared/formatItem';
import * as actionTypes from './actionTypes';

export const addItem = (source, item) => ({
    source,
    item: formatItem(item),
    type: actionTypes.ITEM_ADD,
});

export const itemMarkRead =
    ({ source, id }) =>
    (dispatch) => {
        markItemRead({ source, id });

        dispatch(monitor(source, 'mark_item', 'read'));

        dispatch({
            source,
            id,
            type: actionTypes.ITEM_MARK_READ,
        });
    };

export const itemMarkUnread =
    ({ source, id }) =>
    (dispatch) => {
        markItemUnread({ source, id });

        dispatch(monitor(source, 'mark_item', 'unread'));

        dispatch({
            source,
            id,
            type: actionTypes.ITEM_MARK_UNREAD,
        });
    };
